import { ChargeUser } from "@/model/interface/Charge";

export const CHARGE_PAGE_SIZE_OPTIONS = [25, 50, 100];

export function chargeUserName(user?: ChargeUser | null): string {
  if (!user) {
    return "System";
  }
  const name = [user.firstName, user.lastName].filter(Boolean).join(" ");
  return name || user.email || "Team member";
}

export function formatChargeAmount(amount: number): string {
  return `$${amount.toFixed(amount >= 1 ? 2 : 4)}`;
}
